<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span *ngIf="inputTableData.totalRecords > 0" class="font-bold">{{
        "Therapy Plans Subcription for User - " +
          inputTableData.data[0].userDetails.name
      }}</span>
      <span *ngIf="inputTableData.totalRecords <= 0" class="font-bold"
        >Therapy Plans Subcription for User</span
      >
    </div>
    <div class="flex items-center gap-2">
      <button
        class="btn-color"
        (click)="exportDataFn()"
        nz-button
        nzSize="small"
        nzType="primary"
      >
        <span nz-icon nzType="download"></span>
        Export
      </button>
      <!-- <nz-switch [(ngModel)]="showTestUsers" (ngModelChange)="showTestUserFn()" nzCheckedChildren="hide test user" nzUnCheckedChildren="show test user"></nz-switch> -->
      <div nz-col>
        <button
          class="btn-color"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Clear filter
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #innerTableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold"
        >Session Details - See on top for therapist Details and For Add Extra
        Sessions button(Add Permissions).</span
      >
    </div>
    <div nz-col>
      <button nz-button (click)="scrollToTop()" nzType="primary">
        See Therapist Details
      </button>
    </div>
  </div>
</ng-template>
<nz-table
  #nestedTable
  [nzTitle]="tableHead"
  [nzScroll]="{ y: '500px' }"
  [nzData]="inputTableData.data"
  [nzShowPagination]="true"
  nzFrontPagination="false"
  [nzTotal]="inputTableData.totalRecords"
  [nzPageSize]="pageSize"
  [nzBordered]="true"
  [nzShowSizeChanger]="true"
  [nzPageSizeOptions]="pageSizeOptions"
  [nzPageIndex]="inputTableData.pageNum"
  nzTableLayout="fixed"
  (nzPageIndexChange)="nzPageIndexChange($event)"
  (nzPageSizeChange)="nzPageSizeChange($event)"
>
  <thead>
    <tr>
      <th nzWidth="40px"></th>
      <th>
        Plan Name
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="planNameSearch">
          <span nz-icon nzType="search"></span>
        </nz-filter-trigger>
      </th>
      <th>
        Purchased date
        <nz-filter-trigger
          [nzActive]="true"
          [nzDropdownMenu]="purchasedAtDateFilterMenu"
        >
          <span nz-icon nzTheme="outline" nzType="schedule"></span>
        </nz-filter-trigger>
      </th>
      <th>
        Validity
        <nz-filter-trigger
          [nzActive]="true"
          [nzDropdownMenu]="validTillDateFilterMenu"
        >
          <span nz-icon nzTheme="outline" nzType="schedule"></span>
        </nz-filter-trigger>
      </th>
      <!-- <th>
            Payment Type
            <nz-filter-trigger
              [nzActive]="true"
              [nzDropdownMenu]="paymentTypeMenu"
            >
              <span nz-icon nzTheme="outline" nzType="filter-o"></span>
            </nz-filter-trigger>
          -->
      <th>
        Tags
        <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="tagsFilterMenu">
          <span nz-icon nzTheme="outline" nzType="filter-o"></span>
        </nz-filter-trigger>
      </th>

      <th>Verticle / Concern</th>
      <th>No of completed/total Sessions</th>
      <th>Plan value</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of nestedTable.data">
      <tr>
        <td
          (nzExpandChange)="onExpandChange(data.id!, $event, data)"
          [nzExpand]="expandSet.has(data.id!)"
        ></td>
        <td>{{ data.planName }}</td>
        <td>{{ utils.convertEpochToFormattedDate(data.purchasedAt) }}</td>
        <td>{{ utils.convertEpochToFormattedDate(data.validTill) }}</td>
        <td align="left">
          <ng-container *ngIf="data.tags && data.tags.length > 0; else noTag">
            <nz-tag [nzColor]="'green'" *ngFor="let tag of data.tags">
              {{ utils.convertToTitleCase(tag) }}
            </nz-tag>
          </ng-container>
          <ng-template #noTag>
            <span>N/A</span>
          </ng-template>
        </td>
        <td>
          <div><strong>Vertical:</strong> {{ data.vertical || "N/A" }}</div>
          <div><strong>Concern:</strong> {{ data.concern || "N/A" }}</div>
        </td>
        <td>{{ fractionsOfSessions(data.noOfSessions) }}</td>
        <td>{{ data.planValue ? data.planValue : "N/A" }}</td>
        <td>
          <div class="flex flex-row gap-1">
            <button
              nz-button
              class="save"
              nzShape="circle"
              nz-tooltip
              nzTooltipTitle="Transfer To New Therapist"
              (click)="showModalTransfer(data)"
            >
              <span nz-icon nzType="setting" nzTheme="fill"></span>
            </button>
            <button
              *ngIf="showSendFeedbackButton"
              nz-button
              nzShape="circle"
              nz-tooltip
              nzTooltipTitle="Send feedbacks to therapist"
              (click)="showModalSendFeedback(data)"
            >
              <span nz-icon nzType="file-excel" nzTheme="outline"></span>
            </button>
            <button
              *ngIf="
                showBlockButton && !data.tags?.includes('ADMIN_DEACTIVATED')
              "
              nz-button
              nzType="default"
              nzShape="circle"
              nz-tooltip="Block Plan Subscription"
              (click)="onBlockSubscription(data.id!)"
              class="flex items-center justify-center"
            >
              <i nz-icon nzType="stop" nzTheme="outline"></i>
            </button>
            <button
              *ngIf="data.tags?.includes('ADMIN_DEACTIVATED')"
              nz-button
              nzType="default"
              nzShape="circle"
              nz-tooltip="This plan has been deactivated by admin"
              class="flex items-center justify-center"
              (click)="openBlockMessageModal(data.blockMessage!)"
            >
              <i nz-icon nzType="message" nzTheme="outline"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr [nzExpand]="expandSet.has(data.id!)">
        <nz-table
          #innerTable
          [nzData]="data.sessionDetailslist"
          nzSize="middle"
          [nzShowPagination]="false"
          [nzTitle]="innerTableHead"
        >
          <thead>
            <tr>
              <th>session Date</th>
              <th>Session Name</th>
              <th>Session Description</th>
              <th>Session Booked</th>
              <th>Session Completed</th>
              <th>Session Status</th>
              <th>Is Extra Session</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of innerTable.data">
              <td>
                {{
                  data.sessionDate
                    ? convertDataAndTime(data.sessionDate)
                    : "N/A"
                }}
              </td>
              <td>
                {{ data.sessionName }}
              </td>
              <td>{{ data.description }}</td>
              <td>{{ data.sessionBooked ? "Yes" : "No" }}</td>
              <td>{{ data.sessionCompleted ? "Yes" : "No" }}</td>
              <td>{{ data.sessionStatus }}</td>
              <td>{{ data.extraSession ? "Yes" : "No" }}</td>
            </tr>
          </tbody>
        </nz-table>
      </tr>
    </ng-container>
  </tbody>
</nz-table>

<nz-dropdown-menu #paymentTypeMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Payment Type</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="paymentTypeFilterChangeFn($event)">
          <div *ngFor="let topic of paymentTypeCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="topic.value"
                [ngModel]="topic.checked"
                >{{ topic.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="fetchTherapyPlans()"
        >
          Ok
        </button>
      </div>

      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #tagsFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Tags</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="tagsFilterChangeFn($event)">
          <div *ngFor="let topic of tagsFilterOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="topic.value"
                [ngModel]="topic.checked"
                >{{ topic.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="fetchTherapyPlans()"
        >
          Ok
        </button>
      </div>

      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #validTillDateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker
        [(ngModel)]="validTillColumnFilterDate"
        (ngModelChange)="validTillFilterDateChange($event)"
      ></nz-range-picker>
    </div>
    <div nz-row class="mt-5" nzJustify="end">
      <div nz-col class="mr-1">
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="fetchTherapyPlans()"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #purchasedAtDateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker
        [(ngModel)]="purchasedAtColumnFilterDate"
        (ngModelChange)="purchasedAtFilterDateChange($event)"
      ></nz-range-picker>
    </div>
    <div nz-row class="mt-5" nzJustify="end">
      <div nz-col class="mr-1">
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="fetchTherapyPlans()"
        >
          Ok
        </button>
      </div>
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          class="btn-color"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #planNameSearch="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="planNameColumnSearch"
          nz-input
          placeholder="Search"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="searchByPlanName()"
        >
          Ok
        </button>
        <button
          class="m-1"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
